import { useEffect, useRef } from 'react';

/**
 *  Executes a function on component updates, excluding the initial mount.
 *  Skips the first render and runs only when specified dependencies change.
 *
 *  @param {() => void} fn Callback function to execute after updates.
 *  @param {unknown[]} inputs Dependency array
 */
export const useDidUpdateEffect = (fn: () => void, inputs: unknown[]) => {
  const isMountingRef = useRef(false);

  useEffect(() => {
    isMountingRef.current = true;
  }, []);

  useEffect(() => {
    if (!isMountingRef.current) {
      return fn();
    } else {
      isMountingRef.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, inputs);
};
